import React from 'react';
import { connect } from 'react-redux';
import MenuItem from '../components/MenuItem';
import { signOut } from '../actions';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';

class Menu extends React.Component {

  state = { open: false, type:localStorage.type };
  signOut = () => this.props.signOut();

  componentDidMount() {
    this.fetchType();  
  }

  fetchType () {
    if(localStorage.type) {
      this.setState({type:localStorage.type});
    } else {

      setTimeout(() => { 
        console.log("fetch type again")
        this.fetchType();
      }, 500);

    }
  }

  render()  {
    
    return (
      <div>
        <div className='brand'>
          <img alt="" src="https://static1.squarespace.com/static/575ad32a2eeb81b1d93843b6/59220e88db29d658729e2470/59abf0a2e6f2e1f15716e427/1504440486207/zuzu_logo.png"/>
          <h2 className='title'>Zuzu Admin</h2>
        </div>
        <ul>

          { this.state.type === 'admin' &&
            <div>
              <MenuItem link='/' linkText='Dashboard' iconName='tachometer' />
              <MenuItem link='/businesses' linkText='Businesses' iconName='building' />
            </div>
          }

          { (this.state.type === 'business' || this.state.type === 'admin') &&
            <div>
              <MenuItem link='/charges' linkText='Charges' iconName='money' />
              <MenuItem link='/users' linkText='Users' iconName='group' />
              <MenuItem link='/promotions' linkText='Promotions' iconName='tags' />
            </div>
          }

          { (this.state.type === 'user' || this.state.type === 'business' || this.state.type === 'admin') &&
            <div>
              <MenuItem link='/coupons' linkText='Coupons' iconName='barcode' />
            </div>
          }

          { (this.state.type === 'user' || this.state.type === 'admin') &&
            <div>
              <MenuItem link='/transfers' linkText='Transfers' iconName='money' />
              <MenuItem link='/payouts' linkText='Payouts' iconName='money' />
            </div>
          }

          <li className='menuItem'>
            <div onClick={this.signOut}>
              <Link to="/signIn">
                <FontAwesome  className='menu-icon' name="sign-out" />
                <span className='linkText'>Sign out</span>
              </Link>
            </div>
          </li>

        </ul> 
        <p className='title' 
          style={{
            color: '#fff', 
            textAlign: 'center', 
            position: 'absolute', 
            bottom: 10, 
            left: 70
          }}
        >
          Version 1.2.4
        </p>
      </div>
      
    );
  }
}

const mapsStateToProps = state => ({
  auth: state.auth
});

export default connect(mapsStateToProps, {signOut})(Menu);


// WEBPACK FOOTER //
// ./src/containers/Menu.js